const en = {
	form: {
		transactionTime: 'Transaction Time',
		websiteName: 'Website', // 网站名称
		all: 'All',
		group: 'Group',
		logisticsCompany: 'Logistics company',
		uploadStatus: 'Upload Status',
		transactionId: 'Merchant Transaction ID', // 网站订单号
		trackingNumber: 'Tracking No.',
		logisticsCompanyURL: 'Logistics tracking URL',
		uploaded: 'Uploaded',
		not_uploaded: 'Not Uploaded',
		noLimited: 'No Limit',
		logisticsNumber: 'Tracking No.',
		goodsName: 'Goods name',
		logisticsCompanyName: 'Logistics company'
	},
	warning: {
		start: 'There are',
		end: 'non-uploaded transactions. To avoid affecting the withdrawal, please upload them in time.'
	},
	button: {
		search: 'Search',
		reset: 'Reset',
		upload: 'Bulk Upload',
		download: 'Template Download',
		export: 'Export current results',
		modify: 'Modify',
		uploadByOne: 'Upload',
		cancel: 'Cancel',
		confirm: 'Yes'
	},
	table: {
		orderidAndWebsiteName: 'Merchant Transaction ID/website',
		transactionTime: 'Transaction Time',
		uploadStatus: 'Upload Status',
		goodsName: 'Goods Name',
		orderidAndCompany: 'Tracking No./Logistics company',
		logisticsCompanyURL: 'Logistics tracking URL',
		uploadTime: 'Upload Time',
		operation: 'Operation',
		modify: 'Modify',
		uploadByOne: 'Upload',
		uploaded: 'Uploaded',
		notUploaded: 'Not Uploaded'
	},
	alert: {
		uploadTip: `Firstly, please click 'Export current results'; Secondly, add logistics information; Finally, upload the whole file. `,
		coverTip: 'There are transaction Ids with existing logistics information in the file. Are you sure to overwrite?',
		excTip: 'The following merchant transaction Ids in the file correspond to abnormal field value',
		notExit: 'The following merchant transaction Ids in the file is incorrect and does not exist.',
		moreTip: 'File upload failed. Please correct the field information corresponding to the following merchant order number and re-upload the file.',
		moreNotExit: 'A large number of merchant transaction Ids in the file do not exist or do not need to upload logistics information, please check.',
		upload: 'Upload logistics information',
		modify: 'Modify logistics information',
		uploading: 'Data uploading, please wait, please do not refresh the page'
	},
	message: {
		fieldRequired: 'This field is required',
		downloadFailed: 'Network error, download failed',
		uploadFailed: 'Upload failed',
		uploadSuccess: 'Uploaded successfully'
	},
	autoUpload: {
		intro: 'You can link your website-building tool to upload logistics information automatically.',
		support: '<b class="red">*</b> Currently, only <b class="blue">Shopify/WooCommerce/Shoplazza</b> users are supported for automatic logistics synchronization. Other users can upload one by one or in bulk.',
		schedule: '<b class="red">*</b> Logistics information will be synced automatically at 24:00 (UTC+0) every day.',
		guideTitle: 'How to link website to platform?',
		step1Title: 'STEP 1',
		step1Content: 'Go to <b class="blue">Website Management</b>.',
		step2Title: 'STEP 2',
		step2Content: 'Find the website with the <i class="el-icon-link blue"></i> indicator, click the <i class="iconfont blue">&#xe6a0;</i> button on the right, and choose <b class="blue">Link to Shopify</b>.',
		step3Title: 'STEP 3',
		step3Content: 'Complete the information and click Confirm to finish the authorization.'
	}
}

export default en
